var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8541 12.6465C10.9006 12.693 10.9374 12.7481 10.9626 12.8088C10.9877 12.8695 11.0007 12.9346 11.0007 13.0003C11.0007 13.066 10.9877 13.131 10.9626 13.1917C10.9374 13.2524 10.9006 13.3076 10.8541 13.354C10.8077 13.4005 10.7525 13.4373 10.6918 13.4625C10.6311 13.4876 10.5661 13.5006 10.5004 13.5006C10.4347 13.5006 10.3696 13.4876 10.3089 13.4625C10.2482 13.4373 10.1931 13.4005 10.1466 13.354L5.14664 8.35403C5.10015 8.30759 5.06328 8.25245 5.03811 8.19175C5.01295 8.13105 5 8.06599 5 8.00028C5 7.93457 5.01295 7.86951 5.03811 7.80881C5.06328 7.74811 5.10015 7.69296 5.14664 7.64653L10.1466 2.64653C10.2405 2.55271 10.3677 2.5 10.5004 2.5C10.6331 2.5 10.7603 2.55271 10.8541 2.64653C10.948 2.74035 11.0007 2.8676 11.0007 3.00028C11.0007 3.13296 10.948 3.26021 10.8541 3.35403L6.20727 8.00028L10.8541 12.6465Z",
    fill: "#67667A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeft);
export default __webpack_public_path__ + "static/media/caret-left.4bb4dd7fc5d1acc1b3e80ae5873e49d1.svg";
export { ForwardRef as ReactComponent };